import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { HttpRequest, HttpInterceptor, HttpHandler } from '@angular/common/http';
import { AbTestService } from '@ab-test';
import { isPlatformBrowser } from '@angular/common';
import { SKIP_AB_TEST_HEADERS } from '../../../../projects/platform-manager/src/lib/services/platform-information-token';

@Injectable()
export class AbTestInterceptor implements HttpInterceptor {
  protected isBrowser: boolean;
  constructor(
    private AbTestService: AbTestService,
    @Inject(PLATFORM_ID) platformId: object
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
  }

  intercept(req: HttpRequest<unknown>, next: HttpHandler) {
    const activeTests = this.AbTestService.getActiveTests();
    if (activeTests && this.isBrowser && req.context.get(SKIP_AB_TEST_HEADERS) === false) {
      // only add header in browser and only if request domain is
      // one of these here to not break third party api CORS restrictions
      const domains = [
        'alpy.com',
        'alpinresorts',
        'simplytoski',
        'snowbrainer',
        'slopefox',
        'pistenfuchs',
        'skimarie',
        'location-ski-moins-cher',
        'skidiscount.fr',
        'skidiscount.co',
        'best-price-ski-rental',
        'ekosport-rent.com'
      ];
      // eslint-disable-next-line no-useless-escape
      const pattern = new RegExp(`^(https?:\/\/)?(www\\.)?([a-z0-9-]*\\.)*(${domains.join('|')})`, 'i');
      if (req.url.startsWith('/') || pattern.test(req.url)) {
        const requestWithHeaders = req.clone({
          headers: req.headers.set('X-Alpy-ABTest', JSON.stringify(activeTests))
        });
        return next.handle(requestWithHeaders);
      }
    }
    return next.handle(req);
  }
}
